import $ from "jquery";
import run from "../../../utilities/run";
import {swapClassesViaBool} from "../../../utilities/selectorHelpers";
// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../../stubs/hcuFAQ/hcuFAQ.less");

const faqOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_";

run(faqOuterSelector, ()=>{
	attachGlossary();
});

function attachGlossary(){
	
	deepLinkURL();
	
	/* this function works for both title plus icon (expand/collaps) **/
	$('.hcu-title').click(function(event) {
		event.preventDefault();
		const elId = $(this).find("a").attr("href");
		//location.hash = elId;		
		history.replaceState({},"",elId);
		$(this).next('.hcu-faq-wrapper').toggle();
		const icon = $(this).find('.expand-icon');
		const isOpen = !icon.hasClass('fa-expand');
		swapClassesViaBool(icon, "fa-expand", "fa-compress", isOpen);
		$('.hcu-faq-wrapper').hide();
		$(".hcu-faq-container").removeClass("active q-marg-vert-xs");
		
		if(isOpen){
			$(this).next('.hcu-faq-wrapper').hide();
		}else{
			$(this).next('.hcu-faq-wrapper').show();
		}
	});
	/** expand/collaps FAQs question **/
	$('.hcu-question').click(function(event) {
		event.preventDefault();
		const elId = $(this).closest("a").attr("href");
		history.replaceState({},"",elId);
		const container = $(this).closest('.hcu-faq-container');
		container.toggleClass('active');
		container.toggleClass('q-marg-vert-xs');
	});
	
	/** Expand the FAQs page based on anchor value **/
	
	
	
	
	
	function deepLinkURL(){
		let currentUrl = window.location.href;
	
		if(typeof currentUrl !== "undefined"){			
			openFAQSecionById(currentUrl);
		}
	}
	
	function openFAQSecionById(currentUrl){
		
		if(currentUrl.indexOf("#question") > -1){
			openQuestion(currentUrl);	
		}else if(currentUrl.indexOf("#folder") > -1){
			openFolder(currentUrl);
		}
	}
	
	function openFolder(currentUrl){
		let questionFolder = getIdAfterHash(currentUrl,"#folder");
		let targetFolderId = '#displayContent '+questionFolder;
		let afterToggle = scrollToOffsetFunc(questionFolder);
		$(targetFolderId).children(".hcu-faq-wrapper").show(afterToggle);
	}
	
	function openQuestion(currentUrl){
		let questionId = getIdAfterHash(currentUrl,"#question");
		let targetQuestion = '#displayContent '+questionId;
		const hcuFAQ = $(targetQuestion);
		hcuFAQ.closest('.hcu-faq-wrapper').show();
		hcuFAQ.closest('.hcu-faq-container').addClass("active");
		scrollToOffsetFunc(questionId)();
	}
	
	function getIdAfterHash(currentUrl, hashIdentifier){
		
		let hashId = currentUrl.substring(currentUrl.indexOf(hashIdentifier),currentUrl.length);
		let urlMatcher = new RegExp("[\\?\&\\\/\\*\\$]");
		let matcher = urlMatcher.exec(hashId);
		if(matcher !== null){
			let matcherIndex = matcher.index;
			if(matcherIndex > 0){
				hashId = hashId.substring(0,matcherIndex);
			}	
		}
		return  hashId;
	}
	
	function scrollToOffsetFunc(id){		
		return function(){
			$('html,body').animate({scrollTop: $(id).offset().top - 60});
		};
	}
}


// WEBPACK FOOTER //
// ./src/pages/hcu/hcuFAQ/hcuFAQ.js